import { Component } from '@angular/core';

import config from 'devextreme/core/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  constructor(){
    config({
        thousandsSeparator: ',',
        forceIsoDateParsing: true,
        
    });
  }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/app.component.ts